<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="list-grade">
              <div class="float-left">
                <label class="ml-3">Profile</label>
                <br />
                <label
                  class="ml-3 sub-title-card text-black"
                  >Account Details</label
                >
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/iconsmalluser.svg" @click="GoToProfileParent"/>
              </div>
              <div style="clear: both"></div>

              <hr />

              <div class="float-left" @click="GoToTutorDetail()">
                <label class="ml-3">Tutor</label>
                <br />
                <label class="ml-3 sub-title-card text-black">Tutor Details</label>
              </div>
              <div class="float-right" @click="GoToTutorDetail()">
                <img class="mt-3" src="../../assets/img/icon/icontutordetail.svg" />
              </div>

              <div style="clear: both"></div>
              <hr />

              <div class="float-left">
                <label class="ml-3">Notification</label>
                <br />
                <label class="ml-3 sub-title-card text-black">Manage Notification</label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/iconsmallnoti.svg" />
              </div>

              <div style="clear: both"></div>
              <hr />

              <div class="float-left">
                <label class="ml-3">Link Account</label>
                <br />
                <label class="ml-3 sub-title-card text-black">Link your Account</label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/iconsmalllink.svg" />
              </div>

              <div style="clear: both"></div>
              <hr />

              <div class="float-left">
                <label class="ml-3">Support</label>
                <br />
                <label class="ml-3 sub-title-card text-black">Feedback & FAQ</label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/iconsmallchat.svg" />
              </div>

              <div style="clear: both"></div>
              <hr />

              <div class="float-left">
                <label class="ml-3">About</label>
                <br />
                <label class="ml-3 sub-title-card text-black">About Pickiddo</label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/iconsmallphone.svg" />
              </div>

              <div style="clear: both"></div>
              <hr />

              <div class="float-left">
                <label class="ml-3">Version</label>
                <br />
                <label class="ml-3 sub-title-card text-black">Version 3.0.1</label>
              </div>
              <div class="float-right">
                <img class="mt-3" src="../../assets/img/icon/iconsmallinfo.svg" />
              </div>

              <div style="clear: both"></div>
              <hr />

              <div class="m-0 text-center">
                <CButton class="custom-btn-deactive" @click="SignOut()">Logout</CButton>
              </div>
            </div>

          </div>
        </div>
      </div>
    </CContainer>
    
    <div class="header-top">Settings</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
      GoBack() {
      this.$router.back();
    },
    GoToTutorDetail()
    {
      this.$router.push("/Tutor/TutorDetail");
    },
    GoToProfileParent()
    {
      this.$router.push("/Profile");
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.Signout();
          }
        });
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });

    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.custom-btn-deactive {
 
  /* Body/1/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  color: #f85954;
}
</style>